module.exports = __webpack_public_path__ + "img/madera014.cea5eaaf.jpg";